import React from 'react'
import '../../styles/TabSection/TabSection.scss'

const TabContent = ({ children, active }: Readonly<{
    children: React.ReactNode
    active?: boolean
}>) => {
  return (
        <div className={`tab_content ${active ? 'active' : ''}`}>
            {children}
        </div>
  )
}

export default TabContent
